import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ScrollableDivWithShadow from "./ScrollableDivWithShadow";
import { HGHighlightText } from "../App/App";
import { TrimString } from "../../Utils/StringTrimmer";

const CurrencyDropdown = ({
  disabled,
  showFullCurrencyName,
  menuClassName,
  selected,
  inputWidth,
  dropdownId,
  onChange = () => {},
  width,
  currencyList = [
    {
      ObjectId: 4097542,
      CurrencyName: "AFN",
      CurrencySymbol: "؋",
      IsDefault: false,
    },
  ],
  rightAlign,
  forPricing = false,
  passedStyle
}) => {
  const [selectedCurrency, setSelectedCurrency] = useState(selected ?? {});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchString, setSearchString] = useState("");
  useEffect(() => {
    if (selected) {
      setSelectedCurrency(selected);
    } else {
      setSelectedCurrency(currencyList[0]);
    }
  }, [selected]);
  return (
    <Dropdown
      // alignRight
      className={`${passedStyle ? passedStyle : "transparennt-wrapper-dropdown"}`}
      show={dropdownOpen}
      onToggle={(e) => {
        setDropdownOpen(e);
        // Styling for Add Item modal Currency Dropdown
        if (dropdownId === "add-currencymodal-dropdown" && e) {
          let wrapper = document.getElementById("item-price-input-wrapper");
          console.log(wrapper.offsetWidth);
          const css = `#add-currencymodal-dropdown {
            width: ${wrapper.offsetWidth}px !important; /* Set the width */
            /* You can add more CSS properties here */
          }`;
          const existingStyle = document.getElementById(
            "add-item-currency-dropdown"
          );
          if (existingStyle) {
            existingStyle.remove();
          }
          const style = document.createElement("style");
          style.id = "add-item-currency-dropdown";
          style.innerHTML = css;
          document.body.appendChild(style);
        }
      }}
    >
      <Dropdown.Toggle
        className="w-100 f-12 line-height-18 f-500 f-grey"
        disabled={disabled}
        title={selectedCurrency?.FullCurrencyName}        
      >
        <div className="d-flex align-items-center">
          <div className="f-grey text-ellipsis">
            {selectedCurrency?.CurrencyName}

            {showFullCurrencyName
              ? ` - ${selectedCurrency?.FullCurrencyName}`
              : ""}
          </div>
          {!disabled && (
            <img
              alt=""
              src="/images/big-chevron-down.svg"
              className={`ml-2 ${dropdownOpen ? "rotate180" : ""}`}
            />
          )}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        id={dropdownId}
        className={`${menuClassName} py-2 pl-2 ${forPricing ? 'pricing-dropdown-dir' : 'right-dropdown-dir'}`}
        style={{
          width: "230px",
          minWidth: "120px",
          maxWidth: "500px",
          overflowX: "hidden",
          height: "auto",
        }}
        renderOnMount
      >
        <div className="d-flex align-items-center bg-grey radius-4 mr-2 p-2 search-box-with-border mb-2"
        
        >
          <img
            src="/images/attack-surface/search-icon.svg"
            className="mr-1"
            alt=""
          />
          <input
            type="text"
            className="flex-1 bg-transparent border-none pl-1"
            placeholder="Search"
            value={searchString}
            onChange={(e) => {
              setSearchString(e.target.value);
            }}
            style={{
              width: inputWidth,
            }}
            autoFocus
          />
          <img
            src="/images/settings-v2/header-search-cross.svg"
            alt=""
            className="mx-1 pointer"
            style={{
              visibility: searchString ? "visible" : "hidden",
            }}
            onClick={() => {
              setSearchString("");
            }}
          />
        </div>
        {currencyList?.filter(
          (currency) =>
            currency?.FullCurrencyName?.toLowerCase()?.includes(
              searchString?.toLowerCase()
            ) ||
            currency?.CurrencyName?.toLowerCase()?.includes(
              searchString?.toLowerCase()
            )
        )?.length === 0 && (
          <div className="my-2 f-darkgrey w-100 pl-4">No currencies found</div>
        )}
        <ScrollableDivWithShadow
          className="transparent-scroller"
          style={{
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {currencyList
            ?.filter(
              (currency) =>
                currency?.FullCurrencyName?.toLowerCase()?.includes(
                  searchString?.toLowerCase()
                ) ||
                currency?.CurrencyName?.toLowerCase()?.includes(
                  searchString?.toLowerCase()
                )
            )
            ?.map((item, itemIndex) => {
              return (
                <div
                  key={itemIndex}
                  className="d-flex align-items-center pointer f-grey contextmenu-grey-item"
                  onClick={(e) => {
                    setSelectedCurrency(item);
                    onChange(item);
                    setSearchString("");
                    setDropdownOpen(false)
                    // e.target.closest(".transparennt-wrapper-dropdown").click();
                  }}
                >
                  <img
                    src="/images/msp/dropdown-grey-tick.svg"
                    className="mr-2"
                    alt=""
                    style={{
                      visibility: `${
                        selectedCurrency?.CurrencyName === item?.CurrencyName
                          ? "visible"
                          : "hidden"
                      }`,
                    }}
                  />
                  <span
                    dangerouslySetInnerHTML={{
                      __html: HGHighlightText(
                        TrimString(
                          `${item?.CurrencyName} - ${item?.FullCurrencyName}`,
                          100
                        ),
                        searchString
                      ),
                    }}
                  />
                </div>
              );
            })}
        </ScrollableDivWithShadow>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CurrencyDropdown;
